import axios from 'axios';
import { usePortalStore } from '../stores/portalStore';

export const portalApi = axios.create({
  baseURL: import.meta.env.VITE_API_URL ?? '/api/v1',
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
});

portalApi.interceptors.request.use(config => {
  const { auth } = usePortalStore.getState();
  if (auth?.accessToken) config.headers.Authorization = `Bearer ${auth.accessToken}`;
  if (auth?.tenantSlug) config.headers['X-Tenant-Slug'] = auth.tenantSlug;
  return config;
});

let refreshPromise: Promise<string> | null = null;

portalApi.interceptors.response.use(
  r => r,
  async (error: unknown) => {
    if (!axios.isAxiosError(error)) return Promise.reject(error);
    const original = error.config as (typeof error.config & { _retry?: boolean }) | undefined;
    if (error.response?.status === 401 && original && !original._retry) {
      original._retry = true;
      try {
        if (!refreshPromise) {
          refreshPromise = portalApi.post('/portal/auth/refresh')
            .then(res => res.data.data.access_token as string)
            .finally(() => { refreshPromise = null; });
        }
        const newToken = await refreshPromise;
        usePortalStore.getState().setAccessToken(newToken);
        if (original.headers) original.headers.Authorization = `Bearer ${newToken}`;
        return portalApi(original);
      } catch {
        usePortalStore.getState().clearAuth();
        window.location.href = '/portal/student/login';
      }
    }
    return Promise.reject(error);
  }
);

export function portalApiError(err: unknown): string {
  if (axios.isAxiosError(err)) {
    return err.response?.data?.error?.message ?? err.message;
  }
  return 'An unexpected error occurred';
}
